import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UpdateEconomicGroupUserResponseModel } from '../models/users/responses/update-economic-group-user-response.model';
import { RemoveEconomicGroupUserRequestModel } from '../models/users/requests/remove-economic-group-user-request.model';
import { UpdateUserEmailRequestModel } from '../models/users/requests/update-user-email-request.model';
import { UpdateUserRequestModel } from '../models/users/requests/update-user-request.model';
import { CreateUserResponseModel } from '../models/users/create-user-response.model';
import { CreateUserRequest } from '../models/users/create-user-request.model';
import { UsersResponseModel } from '../models/users/users-response.model';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private api: ApiService
  ) { }

  getUsers(page: number): Observable<UsersResponseModel> {
    return this.api.getUsers(page);
  }

  getUserByEmail(email: string): Observable<UsersResponseModel> {
    return this.api.getUserByEmail(email);
  }
  
  getUserByCnpj(cnpj: string): Observable<UsersResponseModel> {
    return this.api.getUserByCnpj(cnpj);
  }
  
  getUserByGroup(group: string): Observable<UsersResponseModel> {
    return this.api.getUserByGroup(group);
  }

  createUser(request: CreateUserRequest): Observable<CreateUserResponseModel> {
    return this.api.createUser(request);
  }

  updateUserEmail(request: UpdateUserEmailRequestModel) {
    return this.api.updateUserEmail(request);
  }

  updateEconomicGroupUser(request: UpdateUserRequestModel): Observable<UpdateEconomicGroupUserResponseModel> {
    return this.api.updateEconomicGroupUser(request);
  }

  deleteUser(id: number): Observable<any> {
    return this.api.deleteUser(id);
  }

  deleteEconomicGroupUser(request: RemoveEconomicGroupUserRequestModel): Observable<any> {
    return this.api.deleteEconomicGroupUser(request);
  }
 }
